import {on} from './util/event'

var shareEventName = 'share.kiosk.issue';

on(shareEventName, function(e) {
    var  eventData = e.detail,
        id = eventData.id,
        url = eventData.url;
    if(navigator.share){
        navigator.share({
            url: url
        })
    }
});


const issue = {
    shareEvent: shareEventName,
};
export default issue;